import React, { useState, useContext, useEffect } from "react";
import "./styles.scss";

import { CButton } from "@coreui/react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

import { elementToPDF } from "../../../../utils/export";
import Charts from "../../../Charts";
import LoadingStatistics from "../../../LoadingStatistics";
import StatisticFiltersCompare from "../../../StatisticFiltersCompare";
import { DataContext } from "../../Context/DataContext";

export default function ComparacaoEscola({ activity_id: activityId }) {
  const { dataComparisonSchools, loading, firstLoad, fetchData } =
    useContext(DataContext);
  const token = useSelector(state => state.user.token);

  const [data, setData] = dataComparisonSchools;

  const route = "statistics/evaluation_comparison";

  const getRandomColor = () => {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `rgba(${r}, ${g}, ${b}`;
  };

  const colorMap =
    data?.schools?.map((school, index) => ({
      colorBase: `${getRandomColor()}`
    })) || [];

  const changeFilter = selected => {
    if (selected.groupId === 0) {
      return;
    }

    if (selected.regionId === 0) {
      toastr.warning("Atenção", "Preencha o regional");
      return;
    }

    const params = {
      group_id: selected.groupId,
      region_id: selected.regionId,
      activity_id: activityId
    };

    fetchData(params, token, route, setData);
  };

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <div className="layoutTabelaComparacao flex-column w-100">
        <StatisticFiltersCompare
          activityId={activityId}
          onChange={changeFilter}
          hideUser
          hideRoom
          hideSchool
        />
      </div>
      <div className="w-100">
        {loading ? (
          <LoadingStatistics />
        ) : data?.schools?.length > 0 && data ? (
          <div className="w-100">
            <div className="d-flex w-100 justify-content-end mt-3 mb-2">
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  elementToPDF("toPrint", "Comparação entre Escolas.pdf")
                }
              >
                <i className="fa fa-file-pdf-o mr-2"></i> Exportar para PDF
              </CButton>
            </div>
            <div className="w-100" id="toPrint">
              <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
                <div className="row">
                  <div className="chart w-100">
                    <Charts
                      legendY="Escolas"
                      legendX="Nota Média"
                      type="horizontalbar"
                      title="Comparação entre Escolas"
                      data={{
                        labels:
                          data.schools.map((school, index) => school.name) ||
                          [],
                        datasets: [
                          {
                            data: [
                              ...(data.schools.map(school => school.grade) ||
                                []),
                              data.max
                            ],
                            backgroundColor: colorMap.map(
                              color => `${color.colorBase}, 0.2)`
                            ),
                            borderColor: colorMap.map(
                              color => `${color.colorBase}, 1)`
                            ),
                            borderWidth: 1
                          }
                        ]
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : firstLoad ? (
          <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
            <div className="row">
              <div className="chart w-100">
                <div className="d-flex align-items-center justify-content-center w-100 p-5 text-muted text-center">
                  Selecione os filtros para pesquisar
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
            <div className="row">
              <div className="chart w-100">
                <div className="d-flex align-items-center justify-content-center w-100 p-5 text-muted text-center">
                  Nenhuma aplicação da avaliação foi encontrada
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
